import cypherSDK from '@nackle/cypher-sdk';
import { cypherUrl } from 'endpoints';

function CypherService( { access_token, claims } ) {

	const fetchWithAuth = function ( url, options = {} ) {
		options = {
			...options,
			headers: {
				...( options.headers || {} ),
				'authorization': `Bearer ${ access_token }`
			}
		};

		return fetch( url, options );
	};

	const sdk = new cypherSDK( cypherUrl, fetchWithAuth );
	return {
		getStencilInstancesByCodesAndLocales: sdk.getStencilInstancesByCodesAndLocales,
		getCratesByStackCodesAndLocales: sdk.getCratesByStackCodesAndLocales
	};
}

export default CypherService;